export * from './files.service';
import { FilesService } from './files.service';
export * from './main.service';
import { MainService } from './main.service';
export * from './policy.service';
import { PolicyService } from './policy.service';
export const APIS = [FilesService, MainService, PolicyService];
